(function () {
  if (window.tpCart) return;

  if (!customElements.get('tp-timer')) {
    customElements.define('tp-timer', class extends HTMLElement {
      connectedCallback() {
        const mins = Number(this.dataset.minutes) || 10;
        let end = Number(sessionStorage.getItem('tpTimerEnd') || 0);
        if (!end || end < Date.now()) {
          end = Date.now() + mins * 60000;
          try { sessionStorage.setItem('tpTimerEnd', String(end)); } catch (e) {}
        }
        const tick = () => {
          let left = Math.max(0, end - Date.now());
          if (left === 0) {
            end = Date.now() + mins * 60000;
            try { sessionStorage.setItem('tpTimerEnd', String(end)); } catch (e) {}
            left = mins * 60000;
          }
          const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
          this.innerHTML = this.dataset.text.replace('[timer]', m + ':' + String(s).padStart(2, '0'));
        };
        tick();
        this._t = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this._t); }
    });
  }

  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';
  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

  const tpCart = (window.tpCart = {
    busy: false,

    async refresh() {
      const res = await fetch(`${rootUrl()}?sections=cart-drawer,cart-icon-bubble`);
      const data = await res.json();
      const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('.drawer__inner');
      const cur = document.querySelector('#CartDrawer .drawer__inner');
      if (fresh && cur) {
        /* keep the progress bar animating from its old width to the new one */
        const oldFill = cur.querySelector('.tp-goals__fill');
        const oldW = oldFill ? oldFill.style.width : null;
        cur.innerHTML = fresh.innerHTML;
        const newFill = cur.querySelector('.tp-goals__fill');
        if (newFill && oldW && oldW !== newFill.style.width) {
          const target = newFill.style.width;
          newFill.style.width = oldW;
          requestAnimationFrame(() => requestAnimationFrame(() => { newFill.style.width = target; }));
        }
      }
      const drawer = document.querySelector('cart-drawer');
      const freshDrawer = doc.querySelector('cart-drawer');
      if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) {
        const b = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
    },

    async syncGift() {
      const cfg = document.querySelector('[data-tp-gift]');
      if (!cfg || this.busy) return false;
      const vid = Number(cfg.dataset.variant);
      const thr = Number(cfg.dataset.threshold);
      if (!vid) return false;
      this.busy = true;
      try {
        const cart = await fetch(`${cartUrl()}.js`).then((r) => r.json());
        const giftLines = cart.items.filter((i) => i.variant_id === vid);
        const others = cart.items.filter((i) => i.variant_id !== vid);
        /* total after discounts, without the gift (same rule as the original theme) */
        const total = cart.total_price - giftLines.reduce((s, i) => s + i.final_line_price, 0);
        if (others.length && total >= thr && !giftLines.length) {
          await post(`${cartUrl()}/add.js`, { items: [{ id: vid, quantity: 1 }] });
          return true;
        }
        if ((total < thr || !others.length) && giftLines.length) {
          for (const l of giftLines) await post(`${cartUrl()}/change.js`, { id: l.key, quantity: 0 });
          return true;
        }
        if (giftLines.length && giftLines[0].quantity > 1) {
          await post(`${cartUrl()}/change.js`, { id: giftLines[0].key, quantity: 1 });
          return true;
        }
        return false;
      } catch (e) {
        console.error('[tp-cart]', e);
        return false;
      } finally {
        this.busy = false;
      }
    },

    async afterChange() {
      await this.syncGift();
      await this.refresh();
    },

    async add(variantId, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        await post(`${cartUrl()}/add.js`, { items: [{ id: Number(variantId), quantity: 1 }] });
        await this.afterChange();
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
      }
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tp-add]');
    if (!btn) return;
    e.preventDefault();
    tpCart.add(btn.dataset.tpAdd, btn);
  });

  const hook = () => {
    /* constants.js declares PUB_SUB_EVENTS with const, so it is not a window property */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(async () => { if (await tpCart.syncGift()) await tpCart.refresh(); }, 150);
      });
    }
    tpCart.syncGift().then((changed) => { if (changed) tpCart.refresh(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
})();
